import React from "react";
import {
  Typography,
  Grid,
  Divider,
  Paper,
} from "@mui/material";
import Article1Thumb from "../images/Article1Thumb.png"
import PlayerCardRow from "../PlayerCardRow";


export default function Article1(props: any) {

  return (
        <div>
        <Typography
          variant="h4"
          component="h1"
          style={{
            fontWeight: "bold",
            color: "#000000",
            textAlign: "center",
            fontSize: props.isDesktop ? "34pt" : "20pt",
          }}
        >
          Who Will Claim the Throne? The Search for AAA’s Next King After Roman Anthony
        </Typography>
        <Typography
          variant="h6"
          style={{
            fontWeight: "bold",
            marginBottom: "12px",
            color: "rgba(0, 0, 0, 0.7)",
            textAlign: "center",
            fontSize: props.isDesktop ? "18pt" : "14pt",
          }}
        >
          By Duke Hill • June 15th, 2025
        </Typography>
        <Divider variant="middle" style={{ marginBottom: "20px" }} />
        <div style={{margin: "auto", width: "500px", marginBottom: "20px"}}>
        <img
          src={Article1Thumb}
          alt=""
          style={{ maxWidth: "75vw", maxHeight: "400px", border: "#293241 solid 2px",}}
        />
        </div>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          After two and a half months of utter dominance of AAA and the Prospect Savant leaderboard alike, <a href="/player/701350">Roman Anthony</a> was finally afforded a chance to join Boston’s crowded outfield at the big league level due to an injury to Wilyer Abreu. Anthony’s dominance at AAA Worcester was completely unmatched by anyone else at the level, and that’s immediately evident by a glance at his Prospect Savant profile. Among all players who have seen at least 500 pitches in AAA this year, Roman Anthony leads the pack in expected weighted on base average (xwOBA), average exit velocity, 50th percentile exit velocity, and hard hit rate, while sitting at 2nd in many other related categories. He hit a ball 116 mph, flashing absurd raw power. One thing that sets Anthony apart from other high exit velo mashers in AAA is his disciplined plate approach. He draws walks at an elite clip, opting to wait for his pitch, unlike many of the whiff happy, high strikeout rate prospects found at the tops of many top 100 lists (looking at you, Coby Mayo).
        </Typography>
        <Paper
          sx={{
            maxWidth: "85vw",
            height: "100%",
            width: 500,
            border: "#293241 solid 2px",
            boxShadow:
              "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            margin: "auto",
            marginTop: "20px",
            marginBottom: "20px"
          }}
          square
          variant="outlined"
        >

          <div>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              style={{
                backgroundColor: "#BD3039",
                paddingLeft: "10px",
                paddingBottom: "10px",
                marginBottom: "10px",
                wordWrap: "break-word",
              }}
            >
              <span
                style={{
                  marginLeft: "5px",
                  fontSize: props.isDesktop ? "16pt" : "10pt",
                  fontWeight: "bold",
                  marginTop: "12px",
                  color: "#0D2B56",
                }}
              >
                Roman Anthony's 2025 AAA Hitting Percentiles
              </span>
            </Grid>
            <PlayerCardRow
              stat="xwOBA"
              value={"0.441"}
              percentile={100}
              percentile_raw={100}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="xBA"
              value={"0.293"}
              percentile={96}
              percentile_raw={.96}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="xSLG"
              value={"0.559"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="EV"
              value={"95 mph"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Max EV"
              value={"116 mph"}
              percentile={99}
              percentile_raw={.99}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="50th% EV"
              value={"98.8 mph"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="90th% EV"
              value={"109.6 mph"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Barrel %"
              value={"20.3%"}
              percentile={99}
              percentile_raw={.99}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Hard-Hit%"
              value={"57.6%"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="K %"
              value={"21.1%"}
              percentile={64}
              percentile_raw={.64}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="BB %"
              value={"19.2%"}
              percentile={98}
              percentile_raw={.98}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Chase %"
              value={"18.53%"}
              percentile={93}
              percentile_raw={.93}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Whiff %"
              value={"27%"}
              percentile={53}
              percentile_raw={.53}
              isDesktop={props.isDesktop}
            />
          </div>
        </Paper>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Performances this elite and well rounded are extremely rare for a player as young as Anthony, who only recently turned 21. Anthony was the clear “king” of AAA, but now that he’s been called up, who will be the next to wear the crown?
          <br /><br />
          A good place to start would be prospect rankings from outlets such as FanGraphs, Baseball Prospectus, and MLB Pipeline. If we look at the top ranked hitters currently in AAA that are yet to debut, here are some of the names we see:
          <br />
        </Typography>
        <div style={{ margin: "15px" }}>
          • <a href="/player/694212">Samuel Basallo</a> (16th overall by MLB Pipeline, Orioles No. 1 Ranked Prospect)
          <br />
          • <a href="/player/805811">Bryce Eldridge</a> (MLB 19th, SFG 1st)
          <br />
          • <a href="/player/700246">Carson Williams</a> (MLB 21st, TBR 1st)
          <br />
          • <a href="/player/691181">Emmanuel Rodriguez</a> (MLB 29th, MIN 2nd)
          <br />
          • <a href="/player/800050">Chase DeLauter</a> (MLB 49th, CLE 2nd)
        </div>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          If we look further down those lists and factor in PS Score (Prospect Savant’s result/percentiles/age based prospect valuation score), we can add in a few more names such as:
          <br />
        </Typography>
        <div style={{ margin: "15px" }}>
          • <a href="/player/695670">Harry Ford</a> (MLB 63rd, SEA 5th)
          <br />
          • <a href="/player/690976">Alex Freeland</a> (MLB 45th, LAD 4th)
          <br />
          • <a href="/player/683357">Owen Caissie</a> (MLB 46th, CHC 2nd)
          <br />
          • <a href="/player/702222">Justin Crawford</a> (MLB 53rd, PHI 3rd)
        </div>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Let’s also consider a few of the generally unranked prospects who are sitting at the top of Prospect Savant’s PS Score leaderboard, thanks to their strong results in AAA this year:
        </Typography>
        <br />
        <div style={{ margin: "15px" }}>
          • <a href="/player/701678">Hao-Yu Lee</a> (DET 6th)
          <br />
          • <a href="/player/675085">Jonathon Long</a> (CHC 12th)
          <br />
          • <a href="/player/687637">Dylan Beavers</a> (BAL 5th)
        </div>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          So, we have 12 candidates for our AAA Kingsmoot. If we’re going to find someone who could match the absurd production of Roman Anthony, it’ll have to be a player with a high power ceiling based on their max exit velocity who can consistently exhibit said power in game, all while avoiding strikeouts and frequently getting on base. Given these qualifiers, let’s see which players we can rule out.
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/700246">Carson Williams</a> came into 2025 as one of the top contenders for “best player in AAA”, ranked as highly as 7th overall by Baseball Prospectus. It’s easy to see why given the combination of his elite glove at shortstop, great speed, and solid raw power. The question has always been his hit tool, and that question has been answered by AAA pitching. The answer? Bad. My writing? Also bad. Williams has had serious contact issues against breaking pitches, leading to one of the worst whiff rates in AAA at 39.6%. This has led him to strike out at a 34.4% clip, killing any hope of serious production at the plate. Until he can find an answer to making consistent contact, Carson Williams is eliminated from contention for the AAA crown.
          <br /><br /><Divider variant="middle" /><br />
          Much of the same could be said about <a href="/player/691181">Emmanuel Rodriguez</a> - high max exit velocity, elite fielding, and solid speed to boot. He hits some of the hardest balls in all of AAA. Unfortunately like Sir Williams before him, Rodriguez struggles with making contact and carries a 37.1% whiff rate. While he does walk 20% of the time and refuses to swing at anything outside the zone, both of those things seem to be the result of Rodriguez swinging the bat at all. His approach is too passive for how little he can actually make contact, ultimately fueling his main weakness - the strikeout. Here lies Emmanuel Rodriguez, cause of death: 35% K rate.
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/687637">Dylan Beavers’</a>  inclusion among the list of candidates was a bit of an honorable mention seeing as he is not a highly touted prospect by any means, but it’s hard to ignore how well he’s been playing in AAA this year. He’s been doing everything well, sporting a balanced 5 tool profile and getting on base at an elite rate. Unfortunately he doesn’t have a real standout tool, which limits his ceiling. Thus, Beavers will have to remain a minor lord in the Kingdom of AAA.
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/702222">Justin Crawford</a> has succeeded in AAA through a free swinging contact oriented approach, relying on his speed to leg out hits. He makes consistent contact, sporting a 44.4% hard hit rate and rarely whiffing. So, a faster and harder hitting Luis Arraez - what’s not to like? Well, Crawford’s free swinging has been a bit too free, leading to a 35.29% chase rate. Despite the fact that he can hit a ball over 110 mph, Crawford really never attempts to elevate and only has 1 home run through 230 plate appearances. While a .343 batting average is fun to watch, the lack of homers will keep Crawford from being the premiere star of AAA.
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/690976">Alex Freeland</a> has a similar power problem holding him back, but unlike Crawford it has little to do with his approach. Freeland has been a solid hitter in AAA, having the 2nd most doubles and holding a top 10 spot on the extra base hit leaderboard. Despite this, Freeland is yet to hit a ball harder than 110 mph over 473 plate appearances. That’s going to limit Freeland’s homer ceiling going forward - and what’s a king with no power?
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/683357">Owen Caissie</a> has been one of the hardest hitters in AAA for the past couple years, hitting a ball as hard as 115.5 mph in 2024. He’s posted a solid slash line over a whopping 789 AAA plate appearances, and considering how blocked he is in Chicago he will likely rack up some more. Caissie still has time to develop, turning only 23 next month. So, with consistent results and big power, why can’t Caissie be considered the top bat in AAA? You may have started to sense a theme with many of these power hitters; it’s his strikeout rate. Despite the amount of time Caissie has had to learn how to hit AAA pitching, his strikeout rate has only gotten worse in 2025 at 33.6%, up from 28.6% in 2024. His performance over such a sample without improvement to his discipline make Caissie’s profile clear - he’s a three true outcome hitter who may have trouble making consistent contact (especially at the big league level). While he is a premiere power bat, Caissie simply lacks the well rounded profile of Roman Anthony to take over his throne.
          <br /><br /><Divider variant="middle" /><br />
          You may know <a href="/player/695670">Harry Ford</a> from his time playing for Team Britain in the 2023 World Baseball Classic. He’s needed some time to develop thus far, spending a full year at each of A ball, A+, and AA, now in AAA. So far, AAA has been Ford’s most successful stop yet - he’s shown impressive plate discipline and current sports a .317/.429/./497 slashline on the year. While Ford has been successful in every area of his game in 2025, his power ceiling looks more like that of a 15-20 homer hitter. While I do believe Ford could be the next prospect everyone is clamoring over, he’ll have to win over the hearts of fans without the 497 foot grand slams of his would be predecessor.
          <br /><br /><Divider variant="middle" /><br />
          <a href="/player/701678">Hao-Yu Lee</a> has managed to stick around the top of the PS Score leaderboard just under Roman Anthony all year, despite being an unranked and fairly under the radar prospect. His peripherals are great - he hits the ball harder on average than almost anyone in AAA without selling out for power, maintaining an excellent plate approach. However, the actual results have not caught up yet for Lee this year as he is only posting a .743 OPS. Lee turned 22 this year, so he still has some time to turn his elite profile into elite results before Detroit eventually brings him into the fold. Don’t be surprised if Lee’s name eventually starts floating around as one of the best hitters in AAA.
          <br /><br /><Divider variant="middle" /><br />
          While <a href="/player/675085">Jonathon Long</a> is not ranked in the top 100 of many major prospects lists, his 2024 Arizona Fall League and 2025 AAA numbers have been turning heads. He’s performing similarly to his teammate Owen Caissie, but isn’t plagued by poor plate discipline, posting above average strikeout and walk rates. While many prospects with elite raw power may be unable to consistently show it in game, Long has no such issue with his max exit velocity and his 90th percentile exit velocity not being too far off from each other. While Long may have learned to tap into his power, I would love to see him bump his exit velocity ceiling above the 111.6 mph it’s at now before I’m ready to declare him the next big thing in AAA. Needless to say, it won’t be Long before Jonathon is hitting tanks in MLB.
          <br /><br /><Divider variant="middle" /><br />
          While some underdogs have impressed, there’s often something limiting their ceiling that explains why they are often ranked highly on prospect lists. While it would be fun if we could pull an unknown AAA player out of nowhere to be the next big star, the players with true superstar ceiling are ranked at the high end of top 100 lists more often than not. The three main players I see as potential suitors for the AAA throne are Bryce Eldridge, Chase DeLauter, and Samuel Basallo - all players with high consensus rankings.
          <br /><br />
          I’ve had the privilege to watch <a href="/player/805811">Bryce Eldridge</a> play a handful of games at San Francisco’s AA Richmond - he’s a real specimen at 6 foot 7. It’s no wonder the power is real. That being said, AAA has been challenging for Eldridge so far in his short stint with his OPS currently sitting at .492 Still, an adjustment period for any hitter at a new level can be expected. So with many of our other contenders already showing success at AAA, what makes me think that Eldridge can best them? For starters, Eldridge is currently the 2nd youngest hitter in AAA at 20 years and 7 months, giving him more time than his competition to continue to grow and improve. With an 80 (out of 80) future grade from FanGraphs on his raw power and a 70 on his game power, the same as Roman Anthony, Eldridge could easily be showing the same type of production by year’s end. If not this year, I feel confident in saying that he’ll eventually wear the AAA crown.
          <br /><br /><Divider variant="middle" /><br />
          Unlike Eldridge, <a href="/player/800050">Chase DeLauter</a> has immediately taken to AAA in his short stint. Out of everyone on this list, DeLauter has the best FanGraphs hit tool grade for both future and present at a 40/55. Perhaps the truest five tool player on the list, DeLauter can do it all. He’s already been able to access his raw power in game with a 107 mph 90th percentile exit velocity. He can even do one thing that Roman Anthony can’t, and that the other players on this list can only dream of - DeLauter walks more than he strikes out. So, with a great hit tool, plus power, elite discipline, and solid speed, why isn’t DeLauter the clear cut choice to be the next king of AAA? One simple reason - injuries. He’s had trouble staying on the field thus far in his young professional career, but if he manages to stay healthy, the rest of the league should be afraid.
          <br /><br /><Divider variant="middle" /><br />
          While it may seem like the obvious choice considering his prospect ranking and pedigree, my top choice to be the center of attention in AAA is <a href="/player/694212">Samuel Basallo</a>. I mentioned at the beginning of the article that in many of the offensive peripheral categories Roman Anthony wasn’t explicitly leading, he was 2nd - this is because he trails Basallo in multiple stats such as barrel rate and expected slugging. Basallo’s max exit velocity on the season has been 115.9, only .1 under Anthony, and higher than anyone else 23 and under. Speaking of age, Basallo is only 20! He is the 3rd youngest player in AAA, just a few months older than the aforementioned Bryce Eldridge. So, it’s clear that Basallo’s power has already matched that of Roman Anthony. He’s younger than Anthony and is producing on a similar level in AAA this year.. so why isn’t the crown already his? Basallo’s sense of the zone and discipline is unfortunately still below average at this point, and he’s whiffing 32.1% of the time. This hasn’t slowed his production much, however there’s still some clear room for improvement. But, if he does improve his ability to lay off balls out of the zone and make consistent contact, then Samuel Basallo will be the clear consensus number 1 prospect in baseball.
        </Typography>
        <Paper
          sx={{
            maxWidth: "85vw",
            height: "100%",
            width: 500,
            border: "#293241 solid 2px",
            boxShadow:
              "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            margin: "auto",
            marginTop: "20px",
            marginBottom: "20px"
          }}
          square
          variant="outlined"
        >

          <div>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              style={{
                backgroundColor: "#F25D23",
                paddingLeft: "10px",
                paddingBottom: "10px",
                marginBottom: "10px",
                wordWrap: "break-word",
              }}
            >
              <span
                style={{
                  marginLeft: "5px",
                  fontSize: props.isDesktop ? "16pt" : "10pt",
                  fontWeight: "bold",
                  marginTop: "12px",
                  color: "#000000",
                }}
              >
                Samuel Basallo's 2025 AAA Hitting Percentiles
              </span>
            </Grid>
            <PlayerCardRow
              stat="xwOBA"
              value={"0.428"}
              percentile={99}
              percentile_raw={99}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="xBA"
              value={"0.266"}
              percentile={82}
              percentile_raw={.82}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="xSLG"
              value={"0.628"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="EV"
              value={"93.5 mph"}
              percentile={98}
              percentile_raw={.98}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Max EV"
              value={"115.9 mph"}
              percentile={98}
              percentile_raw={.98}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="50th% EV"
              value={"97.6 mph"}
              percentile={99}
              percentile_raw={.99}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="90th% EV"
              value={"108.7 mph"}
              percentile={97}
              percentile_raw={.97}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Barrel %"
              value={"22%"}
              percentile={100}
              percentile_raw={1.00}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Hard-Hit%"
              value={"56%"}
              percentile={98}
              percentile_raw={.98}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="K %"
              value={"24.1%"}
              percentile={47}
              percentile_raw={.47}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="BB %"
              value={"13.6%"}
              percentile={78}
              percentile_raw={.78}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Chase %"
              value={"32.34%"}
              percentile={16}
              percentile_raw={.16}
              isDesktop={props.isDesktop}
            />
            <Divider variant="middle" />
            <PlayerCardRow
              stat="Whiff %"
              value={"32.1%"}
              percentile={23}
              percentile_raw={.23}
              isDesktop={props.isDesktop}
            />

          </div>
        </Paper>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Basallo’s elite power and youth make him the heir apparent and if he refines his approach, AAA’s throne is his.
        </Typography>
      </div>
  );
}
